const rootPath = '/img/png/icons';

const iconsPng = {
  eyeClosed: `${rootPath}/eye-closed.png`,
  eyeOpened: `${rootPath}/eye-opened.png`,
  creatorDashboardViewsEye: `${rootPath}/creator-dashboard-views-eye.png`,
  engagementOrange: `${rootPath}/creator-dashboard-engagement-orange.png`,
  lock: `${rootPath}/lock.png`,
  info: `${rootPath}/info.png`,
  redX: `${rootPath}/red-x.png`,
  addMember: `${rootPath}/add-member.png`,
  lockPassword: `${rootPath}/lock-password.png`,
  userDeactivate: `${rootPath}/user-deactivate.png`,
  locationPin: `${rootPath}/location-pin.png`,
  okHand: `${rootPath}/ok-hand.png`,
  notepad: `${rootPath}/notepad.png`,
  uploadThumbnail: `${rootPath}/upload-thumbnail.png`,
  notepadWithPenOnScreen: `${rootPath}/notepad-with-pen-on-screen.png`,
  pen: `${rootPath}/pen.png`,
  penPurple: `${rootPath}/pen-purple.png`,
  creator: `${rootPath}/creator-icon.png`,
  creatorArticleWhite: `${rootPath}/creator-article-white.png`,
  creatorPostWhite: `${rootPath}/creator-post-white.png`,
  creatorReelWhite: `${rootPath}/creator-reel-white.png`,
  anonymous: `${rootPath}/icon-anonymous.png`,
  pillsDashboard: `${rootPath}/pills-dashboard.png`,
  pillsDashboardWhite: `${rootPath}/pills-dashboard-white.png`,
  pillsGrowthZone: `${rootPath}/pills-growth-zone.png`,
  pillsGrowthZoneWhite: `${rootPath}/pills-growth-zone-white.png`,
  pillsLibrary: `${rootPath}/pills-library.png`,
  pillsLibraryWhite: `${rootPath}/pills-library-white.png`,
  pillsProviders: `${rootPath}/pills-providers.png`,
  pillsProvidersWhite: `${rootPath}/pills-providers-white.png`,
  pillsSupport: `${rootPath}/pills-support.png`,
  pillsSupportWhite: `${rootPath}/pills-support-white.png`,
  pillsRoster: `${rootPath}/pills-roster.png`,
  pillsRosterWhite: `${rootPath}/pills-roster-white.png`,
  pillsPlay: `${rootPath}/pills-play.png`,
  pillsPlayWhite: `${rootPath}/pills-play-white.png`,
  contentLike: `${rootPath}/content-like.png`,
  contentSave: `${rootPath}/content-save.png`,
  contentShare: `${rootPath}/content-share.png`,
  sliderCircleGrey: `${rootPath}/slider-circle-circled.png`,
  sliderCircleUntouched: `${rootPath}/slider-circle-untouched.png`,
  orangeExclamationMark: `${rootPath}/orange-exclamation.png`,
  peerSupportLead: `${rootPath}/peer-support-lead.png`,
  topRightBackground: `${rootPath}/top-right-background-circle.png`,
  personReading: `${rootPath}/person-reading.png`,
  handshake: `${rootPath}/handshake.png`,
  heartInHand: `${rootPath}/heart-in-hand.png`,
  contractLocked: `${rootPath}/contract-locked.png`,
  contactSupport: `${rootPath}/contact-support.png`,
  whiteExclamationOnPurpleTriangle: `${rootPath}/white-exclamation-on-purple-triangle.png`,
  whiteExclamationOnRedSquare: `${rootPath}/white-exclamation-on-red-square.png`,
  wellnessDomainsGray: {
    fun: `${rootPath}/wellness-domains-gray/fun.png`,
    vocational: `${rootPath}/wellness-domains-gray/vocational.png`,
    spiritual: `${rootPath}/wellness-domains-gray/spiritual.png`,
    mental: `${rootPath}/wellness-domains-gray/mental.png`,
    physical: `${rootPath}/wellness-domains-gray/physical.png`,
    purpose: `${rootPath}/wellness-domains-gray/purpose.png`,
    social: `${rootPath}/wellness-domains-gray/social.png`,
  },
  wellnessDomainsPurple: {
    fun: `${rootPath}/wellness-domains-purple/fun.png`,
    vocational: `${rootPath}/wellness-domains-purple/vocational.png`,
    spiritual: `${rootPath}/wellness-domains-purple/spiritual.png`,
    mental: `${rootPath}/wellness-domains-purple/mental.png`,
    physical: `${rootPath}/wellness-domains-purple/physical.png`,
    purpose: `${rootPath}/wellness-domains-purple/purpose.png`,
    social: `${rootPath}/wellness-domains-purple/social.png`,
    readiness: `${rootPath}/wellness-domains-purple/readiness.png`,
  },
};

export default iconsPng;
